import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { VendorGame } from '~/features/vendor-game/types/vendor-game.type';

/**
 * 벤더 게임 목록 조회
 * @description 전체 벤더 게임 목록을 조회합니다
 * @endpoint GET /admin/vendor-games
 * @returns 벤더 게임 목록
 */
export function getVendorGameListApi() {
  return axiosInstance.get<ApiResponse<VendorGame[]>>('/admin/vendor-games');
}
